import React, { useState } from 'react';
import { ReviewTitle, ReviewBody, ReviewReply } from './';
import { Card } from 'wix-style-react';
import { VisibilityDetector } from '../../../../visibility-detector/visibility-detector';
import { biLogger } from '../../../../../bi';
import { useConfigContext } from "../../../../../config-context";
export var SolutionReview = function (props) {
    var _a = useState(false), impressionSent = _a[0], setImpressionSent = _a[1];
    var onImpression = function () {
        var _a, _b, _c;
        if (!impressionSent) {
            biLogger.appMarketReviewImpression({
                appId: props === null || props === void 0 ? void 0 : props.appId,
                review_body: (_a = props === null || props === void 0 ? void 0 : props.review) === null || _a === void 0 ? void 0 : _a.description,
                reviewsScore: (_b = props === null || props === void 0 ? void 0 : props.review) === null || _b === void 0 ? void 0 : _b.rating,
                slug_id: props === null || props === void 0 ? void 0 : props.appName,
                review_index: props === null || props === void 0 ? void 0 : props.index,
                dev_comment: !!((_c = props === null || props === void 0 ? void 0 : props.review) === null || _c === void 0 ? void 0 : _c.replies[0]),
            });
            setImpressionSent(true);
        }
    };
    var isMobile = useConfigContext().isMobile;
    return (React.createElement(VisibilityDetector, { onVisible: function () { return onImpression(); }, onUnVisible: function () {
            return '';
        } },
        React.createElement(Card, null,
            React.createElement("span", { vocab: "https://schema.org/", typeof: "Review" },
                React.createElement(ReviewTitle, { name: props.review.author.userName, publishDate: props.review.publishedAt, rating: props.review.rating }),
                React.createElement("span", { property: "itemReviewed", typeof: "SoftwareApplication" },
                    React.createElement("meta", { property: "name", content: props.appName }),
                    React.createElement("link", { property: "applicationCategory", href: "https://schema.org/WebApplication" }),
                    React.createElement("span", { property: "aggregateRating", typeof: "AggregateRating" },
                        React.createElement("meta", { property: "ratingValue", content: "" + props.averageRating }),
                        React.createElement("meta", { property: "ratingCount", content: "" + props.ratingCount }))),
                React.createElement(ReviewBody, { id: props.review.id, body: props.review.description, title: props.review.title, isMobile: isMobile }),
                props.review.replies && props.review.replies[0] && (React.createElement(ReviewReply, { reply: props.review.replies[0], developerIcon: props.developerIcon, developerName: props.developerName, isMobile: isMobile }))))));
};
//# sourceMappingURL=solution-review.js.map